import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Step1 } from '../../../../shared/models/component-messages/blocCommun/divers/step1';
import { AutoCompleteService } from '../../../../shared/services/auto-complete.service';
import { TypeAdresseCompleteObligatoire } from '../models/TypeAdresseCompleteObligatoire';
@Component({
  selector: 'app-type-adresse-complete-obligatoire',
  templateUrl: './type-adresse-complete-obligatoire.component.html'
})
export class TypeAdresseCompleteObligatoireComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'TypeAdresseCompleteObligatoire';
  @Input() parentForm: FormGroup;
  @Input() disabled: boolean;
  @Input() formName: string;
  @Input() organisme: TypeAdresseCompleteObligatoire;

  public optionsSelect: any[];
  public optionsSelectType = 'CLASSIFICATIONORGANISME';

  public step1 = new Step1();

  constructor(private autoCompleteService: AutoCompleteService) { }

  public ngOnInit() {
    this.optionsSelect = this.autoCompleteService.getOptions(this.optionsSelectType);
    const index = this.optionsSelect.indexOf(this.optionsSelect.find(option => option.libelle == 'Institution Européenne'));
    if (index >= 0) this.optionsSelect.splice(index, 1);

    if(!this.organisme) {
      this.organisme = new TypeAdresseCompleteObligatoire();
    }
    if (!this.organisme.classificationOrganisme) {
        this.organisme.classificationOrganisme = '';
    }
  }

  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }
}

